// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"01d0cbe8","133":"01d0cbe8","860":"ed688cf6","868":"01d0cbe8"}[chunkId] + ".chunk.css";
};